"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HISTORY_CONTEXT = exports.HISTORY_EVENTS = void 0;
exports.HISTORY_EVENTS = {
    created: "record_created",
    updated: "record_updated",
    deleted: "record_deleted",
};
exports.HISTORY_CONTEXT = "history";
//# sourceMappingURL=history.js.map